import type { StaticEntityType } from "@config";
import { cn } from "@lib/cn";
import type { CSSProperties, ReactNode, RefCallback, RefObject } from "react";
import { DividerElement } from "../styles/Divider.styled";
import "../styles/index.scss";
import type { DividerLibraryProps } from "../types";

export const DividerLibrary = ({
  entity,
  editorData,
  editorSlots,
}: {
  entity: StaticEntityType;
  editorData?: {
    borderWidth: string;
    width?: string;
    containerRef?:
      | RefObject<HTMLDivElement | null>
      | RefCallback<HTMLDivElement | null>;
  };
  editorSlots?: { resizeSlot?: ReactNode };
}) => {
  const { settings } = entity as StaticEntityType<DividerLibraryProps>;
  const borderWidth = editorData?.borderWidth || settings.borderWidth;
  const containerRef = editorData?.containerRef;
  const isEditor = !!editorData;
  const width = editorData?.width || settings.width;

  const content = (
    <DividerElement
      {...EDITOR_ATTRIBUTES({ isEditor })}
      className="tw-bg-transparent tw-h-0"
      $borderColor={settings.borderColor}
      $borderWidth={borderWidth}
      $round={settings.round ?? "0"}
    />
  );

  return (
    <div
      className={cn(
        "tw-flex tw-w-full",
        settings.horizontalAlignment === "center" && "tw-justify-center",
        settings.horizontalAlignment === "end" && "tw-justify-end",
        settings.horizontalAlignment === "start" && "tw-justify-start",
      )}
    >
      <div
        ref={containerRef as RefObject<HTMLDivElement>}
        className="tw-w-[var(--entity-size)]"
        style={
          { "--entity-size": width ? `${width}%` : "100%" } as CSSProperties
        }
      >
        {isEditor && editorSlots?.resizeSlot}
        <div
          className="divider-width-wrapper"
          {...EDITOR_ATTRIBUTES({ isEditor: !!editorData })}
        >
          {content}
        </div>
      </div>
    </div>
  );
};

const EDITOR_ATTRIBUTES = ({ isEditor }: { isEditor: boolean }) => {
  const payload: Record<string, string> = {
    "data-dnd-trigger": "true",
  };
  return isEditor ? payload : {};
};
